import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import React from "react";

import ProgressiveImage from "./ProgressiveImage";
import styles from "./Carousel.module.css";

type CslProps = {
  Photos: any[];
  LowResPhotos?: any[];
  Class?: string;
};

const Csl = React.memo(function Csl({ Photos, LowResPhotos = [], Class = "" }: CslProps) {
  const resolveUrl = (mod: any) => {
    // handle both raw string and webpack module with default export
    return typeof mod === "string" ? mod : (mod && (mod.default || mod));
  };

  const isVideo = (url: string) => /\.(mp4|webm|ogg)$/i.test(url);

  return (
    <div>
      <Carousel autoPlay infiniteLoop dynamicHeight swipeable emulateTouch
        className={Class}
        interval={Class === "csl" ? 2500 : 5000}
        transitionTime={500}
        showThumbs={false}
        showStatus={false}
        showIndicators={Class === "csl"} >
        {Photos.map((src, idx) => {
          const url = resolveUrl(src);
          const low = LowResPhotos && LowResPhotos[idx] ? resolveUrl(LowResPhotos[idx]) : undefined;

          return (
            <div key={idx}>
              {isVideo(url) ? (
                <video
                  src={url}
                  poster={low}
                  preload="metadata"
                  controls={false}
                  playsInline
                  loop
                  muted={true}
                  autoPlay={true}
                  className={styles.carouselMedia}
                  onLoadedMetadata={(e) => {
                    // attempt to play programmatically (safe when muted)
                    const v = e.currentTarget as HTMLVideoElement;
                    const p = v.play();
                    if (p && typeof p.catch === 'function') p.catch(() => { /* ignore play rejection */ });
                  }}
                />
              ) : LowResPhotos && LowResPhotos[idx] ? (
                <ProgressiveImage
                  lowSrc={low!}
                  highSrc={url}
                  alt={`carousel-img-${idx}`}
                  mode="absolute"
                />
              ) : (
                <img
                  src={url}
                  srcSet={`${url} 1x, ${url} 2x`}
                  sizes="100vw"
                  loading="lazy"
                  alt={`carousel-img-${idx}`}
                  className={styles.carouselMedia}
                />
              )}
            </div>
          );
        })}
      </Carousel>
    </div>
  );
});

export default Csl;